var _g, _path, _circle, _g2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "account_icon",
    "data-name": "account icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame",
    fill: "#f8f8f8",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shoulders",
    d: "M0,4.472a14.534,14.534,0,0,1,20.975,0A14.492,14.492,0,0,1,10.487,8.944,14.491,14.491,0,0,1,0,4.472Z",
    transform: "translate(4.513 20.123)",
    fill: "#707070"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "head",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(8 6)",
    fill: "#707070"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "highlight",
    fill: "none",
    stroke: "#e72a31",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "drop_down_icon",
    "data-name": "drop down icon",
    d: "M3.5,0,7,6H0Z",
    transform: "translate(45 18) rotate(180)",
    fill: "#f8f8f8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account_icon.a895871d0fcd6b6e73334bef19baac64.svg";
export { ForwardRef as ReactComponent };